import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface VarifiedExpensesState {
  [key: string]: string[];
}

const initialState: VarifiedExpensesState = {};

const varifiedExpensesSlice = createSlice({
  name: "varifiedExpenses",
  initialState,
  reducers: {
    setVarifiedExpenses(state, action: PayloadAction<{ expId: string; expenses: string[] }>) {
      const { expId, expenses } = action.payload;
      state[expId] = expenses;
    },
    addVarifiedExpense(state, action: PayloadAction<{ expId: string; expenseName: string }>) {
      const { expId, expenseName } = action.payload;
      if (!state[expId]) {
        state[expId] = [];
      }
      state[expId].push(expenseName);
    },
  },
});

export const { setVarifiedExpenses, addVarifiedExpense } = varifiedExpensesSlice.actions;
export default varifiedExpensesSlice.reducer;
